// extracted by mini-css-extract-plugin
export var activeDot = "_27-c";
export var buttonContainer = "_27-9";
export var channelButton = "_27-a";
export var content = "_27-0";
export var contentFull = "_27-2";
export var contentThird = "_27-1";
export var contentWrapper = "_27-7";
export var description = "_27-5";
export var heightShort = "_27-e";
export var image = "_27-3";
export var imageContainer = "_27-4";
export var selectButton = "_27-d";
export var spinnerContainer = "_27-b";
export var titleContent = "_27-8";
export var titleWrapper = "_27-6";